const TRUTHY_STRING_VALUES = new Set(['1', 'true']);

/**
 * Determines if a value is considered "truthy" based on specific criteria:
 * - The value is the boolean `true` or the number `1`.
 * - The value is a string that, when trimmed and converted to lowercase, is either "1" or "true".
 *
 * @param {*} value - The value to evaluate.
 * @returns {boolean} - Returns `true` if the value is considered truthy, otherwise returns `false`.
 */
const isTruthyValue = (value) => {
  if (value === true || value === 1) {
    return true;
  }

  if (typeof value === 'string') {
    return TRUTHY_STRING_VALUES.has(value.trim().toLowerCase());
  }

  return false;
};

export default isTruthyValue;
